import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const getParticularchannelAPI = createAsyncThunk(
  "auth/channel/getPaticular",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.get(
        apiRoutes.channelAction("details", 1, id, 1)
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" };
const getparticularDetailschannelSlice = createSlice({
  name: "get particular channel",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetgetparticularchannel: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getParticularchannelAPI.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getParticularchannelAPI.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(getParticularchannelAPI.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetgetparticularchannel } = getparticularDetailschannelSlice.actions;
export const getparticularDetailschannelReducer = getparticularDetailschannelSlice.reducer;
